import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post("/drivers/properties/bulk-update-properties", payload);
  },
  getDriverPropertiesOptions() {
    return Api.get("/drivers/properties/fetch-bulk-upload-options");
  },
};
